export function hasAiItinerarySelections(selectedItinerary) {
  return (selectedItinerary || []).some((day) => (
    (day.locations || []).length > 0
    || (day.restaurants || []).length > 0
    || (day.activities || []).length > 0
    || (day.hotels || []).length > 0
  ));
}

export function buildAiItineraryPayloads(selectedItinerary, startDate, endDate, { clientVisible = true } = {}) {
  const payloads = [];
  if (!startDate || !Array.isArray(selectedItinerary)) return payloads;

  const tripStartDate = new Date(`${startDate}T00:00:00`);
  const tripEndDate = endDate ? new Date(`${endDate}T00:00:00`) : null;

  selectedItinerary.forEach((day) => {
    const dayDate = new Date(tripStartDate);
    dayDate.setDate(dayDate.getDate() + (Number(day.day || 1) - 1));
    if (Number.isNaN(dayDate.getTime())) return;
    if (tripEndDate && (dayDate < tripStartDate || dayDate > tripEndDate)) return;

    let currentHour = 9;
    const pushItem = (item, category, hours) => {
      if (!item?.name) return;
      const startTime = new Date(dayDate);
      startTime.setHours(currentHour, 0, 0, 0);
      const endTime = new Date(startTime);
      endTime.setHours(currentHour + hours, 0, 0, 0);
      payloads.push({
        name: item.name,
        location: day.city || item.location || '',
        google_map_link: '',
        category,
        start_datetime: startTime.toISOString().replace('Z', ''),
        end_datetime: endTime.toISOString().replace('Z', ''),
        description: item.description || '',
        client_visible: clientVisible
      });
      currentHour += hours;
    };

    (day.locations || []).forEach((item) => pushItem(item, 'activity', 2));
    (day.restaurants || []).forEach((item) => pushItem(item, 'restaurant', 1));
    (day.activities || []).forEach((item) => pushItem(item, 'activity', 2));
    (day.hotels || []).forEach((item) => pushItem(item, 'hotel', 2));
  });

  return payloads;
}

export async function appendAiItineraryToTrip(apiClient, tripId, selectedItinerary, startDate, endDate, options = {}) {
  const payloads = buildAiItineraryPayloads(selectedItinerary, startDate, endDate, {
    clientVisible: options.clientVisible !== false
  });
  const created = [];
  for (const payload of payloads) {
    const response = await apiClient.post(`/trips/${tripId}/itinerary`, payload, options.requestConfig || {});
    created.push(response.data);
  }
  return created;
}
